import StatusModal from './StatusModal'
import { FormattedMessage } from 'react-intl'
import messages from '@utils/messages'

interface OrderStatusModalProps {
  open: boolean
  onClose: () => void
  orderStatus?: string | undefined
  orderNumber?: string
}

const orderStatusHeader: React.ReactNode = (
  <FormattedMessage {...messages.ORDER_STATUS} />
)

/* eslint-disable react/jsx-key */
const orderStatusMap: [React.ReactNode, React.ReactNode][] = [
  [
    <FormattedMessage {...messages.NEW} />,
    <FormattedMessage {...messages.DEF_ORDER_STATUS_PENDING} />,
  ],
  [
    <FormattedMessage {...messages.ORDER_STATUS_IN_PROGRESS} />,
    <FormattedMessage {...messages.DEF_ORDER_STATUS_IN_PROGRESS} />,
  ],
  [
    <FormattedMessage {...messages.ORDER_STATUS_COMPLETE} />,
    <FormattedMessage {...messages.DEF_ORDER_STATUS_COMPLETE} />,
  ],
  [
    <FormattedMessage {...messages.ORDER_STATUS_REJECTED} />,
    <FormattedMessage {...messages.DEF_ORDER_STATUS_REJECTED} />,
  ],
]
/* eslint-enable react/jsx-key */

const OrderStatusModal: React.FC<OrderStatusModalProps> = ({
  open,
  onClose,
  orderStatus,
  orderNumber,
}) => {
  return (
    <StatusModal
      open={open}
      onClose={onClose}
      statusHeader={orderStatusHeader}
      statusMap={orderStatusMap}
      orderStatus={orderStatus}
      orderNumber={orderNumber}
    />
  )
}

export default OrderStatusModal
